import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

import { Provider, getServerData, getTemplate } from "@reactivated";

import { denyUrls, ignoreErrors } from "./sentryConfig";

const { props, context } = getServerData();

if (context.SENTRY_DSN) {
    Sentry.init({
        dsn: context.SENTRY_DSN,
        release: context.CI_COMMIT_SHA,
        environment: context.CI_COMMIT_REF_SLUG,
        integrations: [],
        ignoreErrors,
        denyUrls,
    });
}

const main = async () => {
    const Template = await getTemplate(context);

    ReactDOM.hydrateRoot(
        document,
        <Provider value={context}>
            <Template {...props} />
        </Provider>,
    );
};

await main();
